[data-slot='dialog-content'].installation-dialog-container {
	width: 500px;
	max-width: 500px;
	padding-inline-start: 0;
	padding-inline-end: 0;
	padding-bottom: 2rem;
}

[data-slot='dialog-content'].installation-dialog-container h3 {
	font-family: var(--app-title-font-family);
	font-size: 2rem;
}

[data-slot='dialog-content'].installation-dialog-container p {
	font-family: var(--content-font-family);
	font-size: 0.95rem;
}

[data-slot='dialog-content'].installation-dialog-container ol {
	list-style: decimal;
	text-align: start;
}

[data-slot='dialog-content'].installation-dialog-container b {
	font-weight: bold;
}

[data-slot='dialog-content'].installation-dialog-container .installation-dialog > * {
	padding-inline-start: 2rem;
	padding-inline-end: 2rem;
}

.installation-dialog {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.installation-dialog h3 {
	font-size: 3rem;
	font-weight: bold;
	margin-bottom: 10px;
}

.installation-dialog p {
	font-size: 0.8rem;
	line-height: 1.2rem;
	padding: 0 40px;
	margin-bottom: 10px;
}

.installation-dialog p:last-of-type {
	margin-bottom: 20px;
}

.installation-dialog img {
	max-width: 250px;
	margin-bottom: 20px;
}

.installation-dialog button {
	cursor: pointer;
	border: none;
	background: none;
}

.installation-dialog > div {
	width: 100%;
	font-size: 0.8rem;
	height: 50px;
	background: #f9f9f9;
	padding-inline-start: 0;
	padding-inline-end: 0;

	display: flex;
	justify-content: center;
	align-items: center;
}

.installation-dialog button div {
	width: 24px;
	height: 24px;
}

.installation-dialog svg {
	margin: 0px 5px;
	width: 20px;
	stroke: #4e97fd;
}

@media screen and (max-width: 767px) {
	[data-slot='dialog-content'].installation-dialog-container {
		max-width: 90vw;
		height: 300px;
	}
}
